import React,{ useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment"

import { Dialog } from "primereact/dialog";
import { Sidebar } from "primereact/sidebar";

import Menu from "../../helpers/Menu";
import Table  from "../../helpers/Table";
import Button from "../../helpers/Button";
import { CheckboxField, TextAreaField } from "../../helpers";
import Search from "./Components/Search";

import Loading from "../../common/Loading";
import PMUserName from "../../common/PMUserName";
import Description from "../../common/Description";
import ButtonGroup from "../../common/ButtonGroup";
import CopyToClipboard from "../../common/CopyToClipboard";

import { fetchVendorPaymentsPettyCash, updateVendorPaymentPettyCashData, setIsSearchVisible } from "../../services/redux/reducers/vendorPaymentPettyCash/vendorPaymentPettyCash";
import { cancelVendorPaymentsStatus, updateVendorPaymentsStatus, verifyVendorPaymentByFinance } from "../../services/api/vendorPayment";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchStatus } from "../../services/redux/reducers/commonThunk";
import { getFullName, isMobile, numberConversion, round } from "../../utils";

import "./index.css"

import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "../../constants";


const VendorPaymentPettyCash = () => {
    const [isCancelVisible, setIsCancelVisible] = useState(false)

    const [selectedVendorPayments, setSelectedVendorPayments] = useState([])
    const [selectedVendorPaymentsAmount, setSelectedVendorPaymentsAmount] = useState(null)
    const [cancelReason, setCancelReason] = useState()
    const [isLoading, setIsLoading] = useState(false)

    const usersData = useSelector(state => state.userDetails)
    const isTableLoading = useSelector(state => state.vendorPaymentsPettyCash.loading)
    const searchParams = useSelector(state => state.vendorPaymentsPettyCash.searchParams)
    const paginationParams = useSelector(state => state.vendorPaymentsPettyCash.paginationParams)
    const vendorPaymentsData = useSelector(state => state.vendorPaymentsPettyCash.vendorPaymentsPettyCashData)
    const bookingLogs = useSelector(state => state.vendorPaymentsPettyCash.bookingLogs)
    const isSearchVisible = useSelector(state => state.vendorPaymentsPettyCash.isSearchVisible)
    const isSearchActive = useSelector(state => state.vendorPaymentsPettyCash.isSearchActive)

    const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const statusList = useSelector((state) => state.common.status)
    const actionMenu = useRef(null)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const isMobileDevice = isMobile()

    useEffect(() => {
        dispatch(fetchStatus())
    }, [])
   
    useEffect(() => {
        //dispatch(fetchStatus())
    }, [vendorPaymentsData])

    useEffect(() => {
        let totalAmount = 0
        selectedVendorPayments?.map(eachVendorPayment => {
            totalAmount += eachVendorPayment?.amount
        })
        totalAmount = round(totalAmount)
        setSelectedVendorPaymentsAmount(totalAmount)
    }, [selectedVendorPayments])

    const getHeaderCheckbox = () => {
        const relatedSelectedVendorPayments = vendorPaymentsData.filter(eachVendorPayment => {
            const selectedVendorPaymentExists = selectedVendorPayments.some(obj => obj.vendorPaymentId === eachVendorPayment.vendorPaymentId)
            return selectedVendorPaymentExists
        })
        return(
            <div className=""> 
                <CheckboxField onChange={(e) => handleSelectClick(e)} checked={vendorPaymentsData?.length > 0 && vendorPaymentsData?.length === relatedSelectedVendorPayments?.length}/>
            </div>
        )
    }

    const getBodyCheckbox = (row)=>{
        const relatedVendorPayment = selectedVendorPayments?.find(eachVendorPayment => eachVendorPayment?.vendorPaymentId === row?.vendorPaymentId)
        return(
            <CheckboxField onChange={() => handleCheckboxClick(row)} checked={relatedVendorPayment ? true : false}/>
        )
    }

    const getKAMBody = (row)=>{
        let kamName = row["users.firstName"] 

        if(row["users.lastName"]){
            kamName = kamName + " " + row["users.lastName"]
        }
        return <PMUserName userName={kamName} userId={row.createdBy}/>
    }

    const getPaymentNo = (row)=>{
        const date = moment(row?.createdAt).format(DATE_TIME_FORMAT)
        return(
            <div className='req-no-container' style={{position: "relative"}}>
                <div className='flex flex-row justify-content-center align-items-center'>
                    {
                        row?.docNo ? 
                        <>
                            <p className='doc-no' style={{cursor: "pointer"}} onClick={() => window.open(`/sellerpo/${row?.sellerPOId}`)} >{row?.docNo}</p>
                            <CopyToClipboard text={row?.docNo} />
                        </>
                        : ""
                    } 
                </div>
                <p className='mr-4 date'>{date}</p>
            </div>
        )
    }

    const getTxnNo = (row)=>{
        const date = moment(row?.["pettyCash.createdAt"]).format(DATE_TIME_FORMAT)
        return(
            <div className='req-no-container' style={{position: "relative"}}>
            <div className='flex flex-row justify-content-center align-items-center'>
                {
                    row?.["pettyCash.docNo"] ? 
                    <>
                        <p className='doc-no' style={{cursor: "pointer"}} >{row?.["pettyCash.docNo"]}</p>
                        <CopyToClipboard text={row?.["pettyCash.docNo"]} />
                    </>
                    : ""
                } 
            </div>
            <p className='mr-4 date'>{date}</p>
        </div>
        )
    }

    const getStatusBody = (row)=>{
        const relatedStatus = statusList?.find(eachStatus => eachStatus.statusId === row?.statusId)

        if(relatedStatus?.statusId === 10){ // PAYMENT DONE
            return(
                <div className="text-center" style={{fontSize: "13px", color: "green"}} >
                    <div>{relatedStatus?.status}</div>
                </div> 
            )
        }
        if(relatedStatus?.statusId === 11){ // PAYMENT REJECTED
            return(
                <div className="text-center" style={{fontSize: "13px", color: "red"}} >
                    <div>{relatedStatus?.status}</div>
                </div> 
            )
        }
        if(relatedStatus?.statusId === 6){ // CANCELLED
            return(
                <div className="text-center" style={{fontSize: "13px", color: "red"}} >
                    <div>{relatedStatus?.status}</div>
                </div> 
            )
        }
        return(
            <div className="text-center" style={{fontSize: "13px"}} >
                <div>{relatedStatus?.status}</div>
            </div> 
        )
    }

    const getRemarksBody = (row) => row.remarks ? <Description text={row.remarks} maxLength={100} /> : "-"

    const getApprovedByBody = (row)=>{
        let approvedByName = null
        if(row.approvedOrRejectedBy){
            approvedByName = getFullName(row["approvedVendorUsers.firstName"], row["approvedVendorUsers.lastName"])
        }
        else if(row["approvalInstances.processedBy"]){
            const relatedCompanyUser = usersData.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === row["approvalInstances.processedBy"])
            approvedByName = getFullName(relatedCompanyUser.firstName, relatedCompanyUser.lastName)
        }
        return (
            <div className="text-center">
                {
                    approvedByName ?
                    (
                        <div className="text-center">
                            <div>{approvedByName}</div>
                        </div> 
                    ): "-"
                }
            </div>    
        )
    }
    
    const getAmount = (row) =>{
        return numberConversion(row.amount, numberLocale)
    }

    const getBookingStatusBody = (row) => {
        const relatedBookingLog = bookingLogs.find(eachBookingLog => eachBookingLog.docNo === row["pettyCash.docNo"])

        let bookingDate = ""
        if(relatedBookingLog){
            if(relatedBookingLog.bookedAt){
                bookingDate = moment(relatedBookingLog.bookedAt).format(DATE_FORMAT)
            }
            if(relatedBookingLog.unBookedAt){
                bookingDate = moment(relatedBookingLog.unBookedAt).format(DATE_FORMAT)
            }
        }

        return(
            <div className='req-no-container ml-1' style={{position: "relative"}}>
                <div className='flex flex-row justify-content-center align-items-center'>
                    {
                        relatedBookingLog?.["bookedStatus"]? 
                        <>
                            <div className='doc-no'>Yes</div>
                        </>
                        : <div className='doc-no'>No</div>
                    }
                </div>
                <p className='date'>{bookingDate}</p>
            </div>
        )
    }

    const getCancelReason = (row) => {
        return(
            <div className="text-left">{row.cancelReason}</div>
        )
    }

    const tableColumns = [
        {
            header: getHeaderCheckbox, body: getBodyCheckbox
        },
        {
            header: 'Payment No.', style:{ textAlign: "center", minWidth: "100px" }, body: getPaymentNo
        },
        {
            header: 'Txn No', field: '', style:{ textAlign: "center", minWidth: "150px" }, body : getTxnNo
        },
        {
            header : 'KAM', field : '', body : getKAMBody, style:{ textAlign: "center", minWidth: "150px" }
        },
        {
            header: 'Petty Cash Amount', field: 'amount', body : getAmount, style:{ textAlign: "center", minWidth: "120px" }
        },
        {
            header: 'Mode', field: 'paymentMode', style:{ textAlign: "center" }
        },
        {
            header: 'Status', field: '', body: getStatusBody, style:{ textAlign: "center", minWidth: "150px" }
        },
        {
            header: 'Approved By', field: 'approvedBy', body: getApprovedByBody, style:{ textAlign: "center", minWidth: "130px" }
        },
        {
            header: 'Booking Status', field: 'bookingStatus', style:{ textAlign: "center", minWidth: "120px" }, body: getBookingStatusBody, 
        },
        // {
        //     header: 'Note', field: '', style:{ textAlign: "center", minWidth: "100px" }
        // },
        {
            header: 'Remarks', field: '', body: getRemarksBody, style:{ textAlign: "center", minWidth: "250px" }
        },
        {
            header: 'Cancel', field: '', style:{ textAlign: "center", minWidth: "90px" }
        },
        {
            header: 'Cancel Reason', field: 'cancelReason', body: getCancelReason, style:{ textAlign: "left", minWidth: "200px" }
        },
    ]

    const actionMenuItems = [
        {
            label: 'Approve Payments',
            icon: '',
            command : () => handlePaymentDoneClick(),
            permissions: [145]
        },
        {
            label: 'Reject Payments',
            icon: '',
            command : () => handlePaymentRejectClick(),
            permissions: [144]
        },
        {
            label: 'Verify Payments',
            icon: '',
            command : () => handleVerifyClick(),
            permissions: [143]
        },
        {
            label: 'Cancel Payments',
            icon: '',
            command : () => handlePaymentCancelClick(),
            className: "cancel-btn",
            permissions: [142]
        },
    ]

    const handlePageChange = async (e) => {
        let vendorPaymentParams = { 
            ...searchParams,
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            isPettyCashReq: true
        }
        if(!searchParams.statusId){
            vendorPaymentParams.statusIds = [6, 9, 10, 11]
        } else {
            vendorPaymentParams.statusIds = [searchParams.statusId]
        }
        if (vendorPaymentParams.searchBy !== "all") {
            vendorPaymentParams[vendorPaymentParams.searchBy] = vendorPaymentParams.searchText.trim()
        }
        dispatch(fetchVendorPaymentsPettyCash(vendorPaymentParams))
    }

    const handleSearch = () => {
        if(searchParams.searchBy !== "all"){
            if(searchParams.searchText === ""){
                const errorMsgText = searchParams.searchBy.replace(/(_|-)/g, ' ')
                .trim()
                .replace(/\w\S*/g, function(str) {
                    return str.charAt(0).toUpperCase() + str.substr(1)
                })   
                .replace(/([a-z])([A-Z])/g, '$1 $2')
                .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2') 
                return dispatch(raiseToast({severity:'error', summary: errorMsgText, detail: "Please enter search text" , life: 3000}))
            }
        }
        const vendorPaymentParams = {
            ...paginationParams,
            ...searchParams,
            isPettyCashReq: true
        }
        if(!searchParams.statusId){
            vendorPaymentParams.statusIds = [6, 9, 10, 11]
        } else {
            vendorPaymentParams.statusIds = [searchParams.statusId]
        }
        dispatch(fetchVendorPaymentsPettyCash(vendorPaymentParams))
    }

    const handleUpdateVendorPayments = (vendorPaymentIds, updateObj) => {
        console.log("update vendorPaymentIds", vendorPaymentIds, vendorPaymentsData)
        const updatedVendorPayments = vendorPaymentsData.map(eachVendorPayment => {
            console.log("eachVendorPayment id", eachVendorPayment.vendorPaymentId)
            if(vendorPaymentIds.includes(eachVendorPayment.vendorPaymentId)){
                
                const updatedObj = {...eachVendorPayment, ...updateObj}
                console.log("entered update", updatedObj)
                return updatedObj
            }
            return eachVendorPayment
        })
        console.log("updatedVendorPayments", updatedVendorPayments)
        dispatch(updateVendorPaymentPettyCashData([...updatedVendorPayments]))
    }

    const handlePaymentDoneClick = async () => {
        const isAllPaymentApproved = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 9)
        setIsLoading(true)
        if (isAllPaymentApproved){
            const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
            console.log("relatedVendorPaymentIds", relatedVendorPaymentIds)
            if (relatedVendorPaymentIds?.length > 0){
                const data = {
                    vendorPaymentIds : relatedVendorPaymentIds,
                    statusId : 10,
                    processedBy : usersData?.userId,
                    processedAt : new Date()
                }
                if(window.confirm("Are you sure you want to process selected vendor payments")){
                    const response = await updateVendorPaymentsStatus(data)
                    if (response.failure){
                        dispatch(raiseToast({severity:'error', summary: "Payments", detail: response?.data?.error, life: 3000}))
                    }else {
                        const reduxUpdateObj = {
                            statusId: 10,
                            processedBy: usersData?.userId,
                            processedAt: new Date().toISOString().split('.')[0] + '.000Z'
                        }
                        handleUpdateVendorPayments(relatedVendorPaymentIds, reduxUpdateObj)
                        handleSearch()
                        dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Payments Done Successfully", life: 3000}))
                        setSelectedVendorPayments([])
                    }
                }
            }else {
                dispatch(raiseToast({severity:'warn', detail: "Select the Payments", life: 3000}))
            }
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Approved.", life: 3000}))
        }
        setIsLoading(false)
    }

    const handlePaymentCancelClick = async () => {
        const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
        const isAllPaymentDone = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 10)
        if (isAllPaymentDone){
            if (relatedVendorPaymentIds?.length > 0){
                setIsCancelVisible(true)
            }else{
                dispatch(raiseToast({severity:'warn',detail: "Select the Payments", life: 3000}))
            }
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Payment Done", life: 3000}))
        }
    }

    const handleCancelClick = async () => {
        const isAllPaymentDone = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 10)
        setIsLoading(true)
        if (isAllPaymentDone){
            const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
            const data = {
                vendorPaymentIds : relatedVendorPaymentIds,
                statusId : 6,
                processedBy : usersData?.userId,
                processedAt : new Date(),
                cancelReason : cancelReason
            }
            if(window.confirm("Are you sure you want to cancel selected vendor payments")){
                const response = await cancelVendorPaymentsStatus(data)
                if (response.failure){
                    dispatch(raiseToast({severity:'error', summary: 'Cancel Payments', detail: response?.data?.error, life: 3000}))
                }else {
                    const reduxUpdateObj = {
                        statusId: 6,
                        processedBy: usersData?.userId,
                        processedAt: new Date().toISOString().split('.')[0] + '.000Z',
                        cancelReason: cancelReason
                    }
                    handleUpdateVendorPayments(relatedVendorPaymentIds, reduxUpdateObj)
                    dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Payments Cancelled Successfully", life: 3000}))
                    setSelectedVendorPayments([])
                }
            }
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Payment Done", life: 3000}))
        }
        setIsLoading(false)
    } 

    const handlePaymentRejectClick = async () => {
        const isAllPaymentApproved = selectedVendorPayments?.every(eachVendorPayment => eachVendorPayment?.statusId === 9)
        setIsLoading(true)
        if (isAllPaymentApproved){
            setIsLoading(true)
            const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
            if (relatedVendorPaymentIds?.length > 0){
                const updateObj = {
                    vendorPaymentIds : relatedVendorPaymentIds,
                    statusId : 11,
                    processedBy : usersData?.userId,
                    processedAt : new Date()
                }
                if(window.confirm("Are you sure you want to reject selected vendor payments")){
                    const response = await updateVendorPaymentsStatus(updateObj)
                    if (response.failure){
                        dispatch(raiseToast({severity:'error', summary: "Reject Payments", detail: response?.data?.error, life: 3000}))
                    }else {
                        const reduxUpdateObj = {
                            statusId: 11,
                            processedBy: usersData?.userId,
                            processedAt: new Date().toISOString().split('.')[0] + '.000Z'
                        }
                        handleUpdateVendorPayments(relatedVendorPaymentIds, reduxUpdateObj)
                        setSelectedVendorPayments([])
                        dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Payments Rejected Successfully", life: 3000}))
                    }
                }
            }else{
                dispatch(raiseToast({severity:'warn', detail: "Select the Payments", life: 3000}))
            }
            setIsLoading(false)
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Only Select the Payments which are Approved.", life: 3000}))
        }
        setIsLoading(false)
    }

    const handleVerifyClick = async () => {
        const relatedVendorPaymentIds = selectedVendorPayments?.map(eachVendorPayment => eachVendorPayment?.vendorPaymentId)
        setIsLoading(true)
        if (relatedVendorPaymentIds?.length > 0){
            const data = {
                vendorPaymentIds : relatedVendorPaymentIds,
                processedBy : usersData?.userId,
                processedAt : new Date()
            }
            const response = await verifyVendorPaymentByFinance(data)
            if (response.failure){
                dispatch(raiseToast({severity:'error', summary: 'Verify Payments', detail: response?.data?.error, life: 3000}))
            }else {
                dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Payments Verified Successfully", life: 3000}))
            }
        }else{
            dispatch(raiseToast({severity:'warn', detail: "Select the Payments", life: 3000}))
        }
        setIsLoading(false)
    }

    const handleCheckboxClick = (row) => {
        const relatedVendorPayment = selectedVendorPayments?.find(eachVendorPayment => eachVendorPayment?.vendorPaymentId === row?.vendorPaymentId)
        if (relatedVendorPayment){
            const relatedVendorPayments = selectedVendorPayments?.filter(eachVendorPayment => eachVendorPayment?.vendorPaymentId !== relatedVendorPayment?.vendorPaymentId)
            setSelectedVendorPayments(relatedVendorPayments)
        }else {
            const relatedVendorPayments = [...selectedVendorPayments, row]
            setSelectedVendorPayments(relatedVendorPayments)
        }
    }

    const handleSelectClick = (e) => {
        const relatedVendorPayments = vendorPaymentsData?.map(eachVendorPayment => eachVendorPayment)
        let updatedVendorPayments = [...selectedVendorPayments]

        if (e.checked){
            relatedVendorPayments.map(eachVendorPayment => {
                const relatedSelectedVendorPaymentExists = selectedVendorPayments.some(obj => obj.vendorPaymentId === eachVendorPayment.vendorPaymentId)
                if(!relatedSelectedVendorPaymentExists){
                    updatedVendorPayments = [...updatedVendorPayments, eachVendorPayment]
                }
            })
            setSelectedVendorPayments(updatedVendorPayments)
        }else{
            relatedVendorPayments.map(eachVendorPayment => {
                const relatedSelectedVendorPaymentExists = selectedVendorPayments.some(obj => obj.vendorPaymentId === eachVendorPayment.vendorPaymentId)
                if(relatedSelectedVendorPaymentExists){
                    updatedVendorPayments = updatedVendorPayments.filter(obj => obj.vendorPaymentId !== eachVendorPayment.vendorPaymentId)
                }
            })
            setSelectedVendorPayments(updatedVendorPayments)
        }
    }

    const resetSelectedVendorPayments = () => {
        setSelectedVendorPayments([])
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }

    const actionButtons = [
        {
            label: "RESET",
            command: (event) => resetSelectedVendorPayments(),
        },
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
    ]

    return (
        <div>
            <div className="vp-petty-cash-layout flex flex-column">
                <div className="flex flex-column md:flex-row md:justify-content-between">
                    <h4 className="mx-2 my-1 md:m-2">VENDOR PAYMENT PETTY CASH</h4>
                    <div className="flex flex-column md:flex-row justify-content-between mb-2">
                        <div className="md:mr-2 md:mb-0 mb-2 ml-2">
                            <p className="mb-0 mt-2 selected-amount" style={{fontSize: "15px"}}>Selected Amount: {selectedVendorPaymentsAmount}</p>
                        </div>
                        <div className="mr-2 flex justify-content-end">
                            {/* <Button className="h-2rem ml-2 p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="RESET" onClick={resetSelectedVendorPayments} /> */}
                            <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                            {/* <Button className="h-2rem ml-2 p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                            <Button icon="pi pi-filter" className={`h-2rem ml-2 p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                            <ButtonGroup buttons={actionButtons} />
                        </div>
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div className="" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                        <div className='p-card mb-0' >
                            <div className="flex-grow-1 petty-cash-table" >
                                <Table
                                    page={paginationParams.pageNo}
                                    onPageChange={(e)=> handlePageChange(e)} 
                                    totalRecords={paginationParams.totalRecords}
                                    tableColumns={tableColumns}
                                    rows={paginationParams.recordsPerPage}
                                    data={vendorPaymentsData}
                                    scrollable={"true"}
                                    paginator
                                    loading={isTableLoading}
                                    lazy
                                />
                            </div>
                        </div>
                    </div>
                    {
                        isSearchVisible && !isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                            <Search />
                        </div>
                    }
                    {
                        isSearchVisible && isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                            <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                                <Search />
                            </Sidebar>
                        </div>
                    }
                     <Loading visible={isLoading}/>
                    <Dialog header="Vendor Payment Petty Cash Cancel" visible={isCancelVisible} style={{ width: '35vw', height: '30vh' }} onHide={() => setIsCancelVisible(false)}>
                        <div>
                            <div className="grid">
                                <div className="flex flex-column col-12 mb-2 lg:col-8 lg:mb-0">
                                    <TextAreaField name="reason" labelText="Cancel Reason" value={cancelReason} onChange={e => setCancelReason(e.target.value)}/>
                                </div>
                            </div>
                            <div className="flex justify-content-end mt-4">
                                <Button className="h-2rem  p-2" label="Cancel" onClick={handleCancelClick}/>   
                            </div>
                        </div>
                    </Dialog>

                    <Loading visible={isLoading}/>
                </div>
            </div>
        </div>
    )
}

export default VendorPaymentPettyCash;
